import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
export const getErpParameters = createAsyncThunk(
  "/erpParameter/get",
  async (_, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/parameters/getErpParametersByFirm");
      if (isSuccess) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const erpParameterSlice = createSlice({
  name: "erpParameter",
  initialState: {
    erpParameter: [],
    bankMatchList: [], // Bank match buraya eklenip sayfadan da bu veri çekilecek
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    selectedErpBankCode: "",

    projectCodes: [],
    salesmanCodes: [],
    specialCodes: [],
    authCodes: [],
    referenceCodes: [],
    dekontSerialCodes: [],
  },
  reducers: {
    clearState: (state) => {
      state.erpParameter = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
    onBankMatchSelect: (state, { payload }) => {
      var body = payload.responseBody;
      if (body && body.length > 0) {
        state.selectedErpBankCode = JSON.parse(body).bankCode;
      }
      return state;
    },
    onVirementCustomerSelect: (state, { payload }) => {
      var body = payload.responseBody;
      if (body && body.length > 0) {
        state.selectedErpBankCode = JSON.parse(body).bankCode;
      }
      return state;
    },
    clearBankMatchSelect: (state, { payload }) => {
      state.selectedErpBankCode = "";

      return state;
    },
    onErpParametersSelect: (state, { payload }) => {

      state.projectCodes = payload.ProjectCodes;
      state.salesmanCodes = payload.SalesmanCodes;
      state.specialCodes = payload.SpecialCodes;
      state.authCodes = payload.AuthCodes;
      state.referenceCodes = payload.ReferenceCodes;
      state.dekontSerialCodes = payload.DekontSerialCodes;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getErpParameters.fulfilled, (state, { payload }) => {
      state.erpParameter = payload;

      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getErpParameters.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
    });
    builder.addCase(getErpParameters.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState, onBankMatchSelect, clearBankMatchSelect, onErpParametersSelect } = erpParameterSlice.actions;

export const erpParameterSelector = (state) => state.erpParameter;

export const erpParameterReducer = erpParameterSlice.reducer;
